
import phone1 from '../assets/images/phone/1.png'
import phone2 from '../assets/images/phone/2.png'
import phone3 from '../assets/images/phone/3.png'
import phone4 from '../assets/images/phone/4.png'
import phone5 from '../assets/images/phone/5.png'
import phone6 from '../assets/images/phone/6.png'
import phone7 from '../assets/images/phone/7.png'
import phone8 from '../assets/images/phone/8.png'

import client1 from '../assets/images/client/01.jpg'
import client2 from '../assets/images/client/02.jpg'
import client3 from '../assets/images/client/03.jpg'
import client4 from '../assets/images/client/04.jpg'
import client5 from '../assets/images/client/05.jpg'
import client6 from '../assets/images/client/06.jpg'

import company1 from '../assets/images/client/amazon.svg'
import company2 from '../assets/images/client/google.svg'
import company3 from '../assets/images/client/lenovo.svg'
import company4 from '../assets/images/client/paypal.svg'
import company5 from '../assets/images/client/shopify.svg'
import company6 from '../assets/images/client/spotify.svg'

import { FiDatabase, FiEye, FiFeather, FiHeart, FiMaximize, FiNavigation2, FiPieChart, FiSmartphone, FiUserCheck } from "react-icons/fi"
import { AiOutlineSafety } from "react-icons/ai";
import { BiSolidPhotoAlbum } from "react-icons/bi";
import { FaPhotoFilm } from "react-icons/fa6";
import { MdPhotoAlbum, MdDevices  } from "react-icons/md";
import { FaShareAlt } from "react-icons/fa";

export const feature = [
    {
        icon:FiMaximize,
        title:'Fully functional',
        desc:'The phrasal sequence of the is now so that many campaign and benefit',
        active:true
    },
    {
        icon:FiPieChart,
        title:'Secure Data',
        desc:'The phrasal sequence of the is now so that many campaign and benefit',
        active:false
    },
    {
        icon:FiNavigation2,
        title:'Track Location',
        desc:'The phrasal sequence of the is now so that many campaign and benefit',
        active:true
    },
    {
        icon:FiDatabase,
        title:'Data Analyse',
        desc:'The phrasal sequence of the is now so that many campaign and benefit',
        active:false
    },
]

export const feature2 = [
    {
        icon:AiOutlineSafety,
        title:'Secure Cloud Storage',
        desc:'Store your precious memories safely with Heartfelt’s cloud storage.'
    },
    {
        icon:BiSolidPhotoAlbum,
        title:'Beautiful Digital Albums',
        desc:'Create visually stunning albums to organize your memories.'
    },
    {
        icon:FaPhotoFilm,
        title:'High-Quality Photo & Video Uploads',
        desc:'Upload photos and videos in high resolution without compression,'
    },
]
export const feature3 = [
    {
        icon:MdPhotoAlbum,
        title:'Easy Album Organization',
        desc:'Sort your albums by event type, date, or custom categories.'
    },
    {
        icon:FaShareAlt,
        title:'Share with Loved Ones',
        desc:'Easily share your albums with friends and family through private links or invitations.'
    },
    {
        icon:MdDevices,
        title:'Mobile & Web Access',
        desc:'Access your memories anytime, anywhere through our user-friendly mobile app and web platform.'
    },
]

export const screenshotImg = [
    phone1, phone2, phone3, phone4, phone5, phone6, phone7,
]

export const faq = [
    {
      id: 1,
      title: 'How does HeartFelt work?',
      desc: 'HeartFelt helps you securely store and organize your special moments—like weddings or birthdays—into beautifully crafted digital and QR albums you can relive anytime.',
    },
    {
      id: 2,
      title: 'Is my data safe on HeartFelt?',
      desc: 'Yes, your data is protected with end-to-end encryption and secure cloud storage. Only you and those you choose can access your content.',
    },
    {
      id: 3,
      title: 'Can I share my albums with others?',
      desc: 'Absolutely. Share your albums through private links or invite friends and family to view, comment, or contribute memories.',
    },
    {
      id: 4,
      title: 'Can I download my photos and videos?',
      desc: 'Yes, you can download your photos and videos anytime to keep local backups or print them as keepsakes.',
    },
];  

export const clientData = [
    {
      image: client1,
      name: 'Amit Sharma',
      position: 'Wedding Photographer',
      desc: `"HeartFelt made storing and sharing my clients' wedding albums effortless. The security and quality are unmatched!"`,
      rate: ['mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star'],
    },
    {
      image: client2,
      name: 'Priya Verma',
      position: 'Event Planner',
      desc: `"I love how HeartFelt keeps my event memories secure and beautifully organized. It's a must-have for any celebration!"`,
      rate: ['mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star'],
    },
    {
      image: client3,
      name: 'Rahul Mehta',
      position: 'IT Professional',
      desc: `"I uploaded all my wedding photos to HeartFelt, and it’s been amazing! Secure, user-friendly, and accessible anywhere."`,
      rate: ['mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star'],
    },
    {
      image: client4,
      name: 'Sneha Iyer',
      position: 'Travel Blogger',
      desc: `"HeartFelt is perfect for keeping my travel and event memories safe. Sharing albums with friends and family is so easy!"`,
      rate: ['mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star'],
    },
    {
      image: client5,
      name: 'Vikram Rajput',
      position: 'Cinematographer',
      desc: `"Storing videos from my projects has never been easier. HeartFelt provides excellent quality and secure access, every time."`,
      rate: ['mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star'],
    },
    {
      image: client6,
      name: 'Ananya Kapoor',
      position: 'Homemaker',
      desc: `"I use HeartFelt to store all my family's memories. From birthdays to weddings, everything is safe, organized, and easy to access!"`,
      rate: ['mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star'],
    },
  ];
  

export const companyData = [
    company1,company2,company3,company4,company5,company6
]